import React from 'react';
import { Alert, Grid, Tabs, Typography } from 'antd';
import { SettingOutlined, EnvironmentOutlined, SafetyCertificateOutlined, SlidersOutlined, LockOutlined } from '@ant-design/icons';
import { useUser } from '../../../UserContext';
import OperationSettings from './OperationSettings';
import GeoSettings from './geo/GeoSettings';
import BotProtectionSettings from './security/BotProtectionSettings';
import './Configuraciones.css';
const sections = [
  {key:'geo', title:'Mapas y proveedores', description:'Servicios, claves e historial', icon:EnvironmentOutlined, content:GeoSettings},
  {key:'security', title:'Protección contra bots', description:'Acceso al control público', icon:SafetyCertificateOutlined, content:BotProtectionSettings},
  {key:'operation', title:'Operación y validaciones', description:'Códigos OTP y notificaciones', icon:SlidersOutlined, content:OperationSettings},
];
export default function Configuraciones() {
  const {user}=useUser();
  const screens=Grid.useBreakpoint();
  if(!user?.es_administrador)return <Alert type="warning" message="Esta sección requiere acceso de administrador." />;
  return <div className="settings-page">
    <header className="settings-hero">
      <div className="settings-hero-main">
        <span className="settings-hero-icon"><SettingOutlined /></span>
        <div><span className="settings-eyebrow">ADMINISTRACIÓN</span><Typography.Title level={2}>Configuraciones</Typography.Title>
          <Typography.Paragraph>Personaliza los servicios y las validaciones de tu operación.</Typography.Paragraph></div>
      </div>
      <span className="settings-admin-badge"><LockOutlined /> Acceso de administrador</span>
    </header>
    <Tabs className="settings-sections" tabPosition={screens.lg?'left':'top'} defaultActiveKey="geo" items={sections.map(({key,title,description,icon:Icon,content:Content})=>({
      key,label:<span className="settings-nav-item"><span className="settings-nav-icon"><Icon /></span><span><strong>{title}</strong><small>{description}</small></span></span>,children:<Content />,
    }))} />
  </div>;
}
